import React from 'react'
import Footer from './components/Footer';
import AllComponents from './components/AllComponents';
import ContactHeading from './ContactPage/ContactHeading';
import ContactSection from './ContactPage/ContactSection';
import { CartProvider } from 'react-use-cart';

function Contact() {
  return (
    <CartProvider>
      <AllComponents />
      <ContactHeading />
      <ContactSection />
      <Footer />
    </CartProvider>
  )
}

export default Contact;